import { ChangeEvent, useState } from 'react';
import { useTheme } from 'styled-components';

import { EmailIcon, LeftAngleIcon } from '../../../../../assets/svg';
import { Input } from '../../../../../components/input';
import { useFloatingAlert } from '../../../../../hooks/useFloatingAlert';
import { useMerchant } from '../../../../../hooks/useMerchant';
import { PaymentLinksMultiuseServices } from '../../../../../services/payment-links-multiuse';
import {
	BackButtonContainer,
	BackText,
	Button,
	SendLinkButtonContainer,
	ShareView,
	TabBody,
} from '../styles';

type LinkStepsAllowed = 'principal' | 'email' | 'whatsapp' | 'sms';

interface SendLinkByValues {
	email: string;
	whatsapp: string;
	sms: string;
	loading: boolean;
}

const defaultSendLinkBy: SendLinkByValues = {
	email: '',
	whatsapp: '',
	sms: '',
	loading: false,
};

interface SendLinkProps {
	paymentLinkUrl: string;
	id: string;
}

const SendLinkTab = ({ id, paymentLinkUrl }: SendLinkProps) => {
	const { colors } = useTheme();
	const { handleShowAlert } = useFloatingAlert();
	const { merchantSelected } = useMerchant();
	const [sendLinkStep, setSendLinkStep] = useState<LinkStepsAllowed>('principal');
	const [sendLinkBy, setSendLinkBy] = useState<SendLinkByValues>(defaultSendLinkBy);

	const handleChangeInput = async (e: ChangeEvent<HTMLInputElement>) => {
		const { value, name } = e.target;
		if (/^\d{0,10}$/.test(value) && name != 'email') {
			setSendLinkBy({ ...sendLinkBy, [name]: value });
		}

		name == 'email' && setSendLinkBy({ ...sendLinkBy, [name]: value });
	};

	const handleSendLinkByEmail = async () => {
		setSendLinkBy({ ...sendLinkBy, loading: true });

		try {
			await PaymentLinksMultiuseServices.sendPaymentMultiuseLinkBy({
				merchantCode: merchantSelected?.code as string,
				presessionToken: paymentLinkUrl.split('/').slice(-1)[0],
				wayToShare: 'email',
				email: sendLinkBy.email,
			});
			handleShowAlert({ message: 'Enlace de pago enviado', type: 'success' });
			handlePreviousStep();
		} catch (error) {
			handleShowAlert({
				message: 'No pudimos enviar el enlace de pago',
				type: 'error',
			});
		} finally {
			setSendLinkBy({ ...sendLinkBy, loading: false });
		}
	};

	const handlePreviousStep = () => {
		setSendLinkStep('principal');
		setSendLinkBy(defaultSendLinkBy);
	};

	return (
		<>
			<TabBody id={id}>
				{sendLinkStep !== 'principal' && (
					<BackButtonContainer onClick={handlePreviousStep}>
						<LeftAngleIcon />
						<BackText>Regresar</BackText>
					</BackButtonContainer>
				)}

				{sendLinkStep === 'principal' && (
					<ShareView>
						<Button
							onClick={() => setSendLinkStep('email')}
							style={{ justifyContent: 'flex-start' }}
						>
							<EmailIcon color={colors.principal.pure} /> Correo electrónico
						</Button>
					</ShareView>
				)}

				{sendLinkStep === 'email' && (
					<>
						<Input
							label="Correo electrónico"
							name="email"
							value={sendLinkBy.email}
							onChange={handleChangeInput}
							variant="large"
						/>

						<SendLinkButtonContainer>
							<Button onClick={handleSendLinkByEmail} disabled={sendLinkBy.loading}>
								{sendLinkBy.loading ? 'Enviando...' : 'Enviar'}
							</Button>
						</SendLinkButtonContainer>
					</>
				)}
			</TabBody>
		</>
	);
};

export { SendLinkTab };
